<div
    class="tooltip fixed bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg p-4 text-gray-900 dark:text-gray-100 z-50 animate-fade-in"
    [ngClass]="position"
    [style.left.px]="left"
    [style.top.px]="top"
>
    <div>
        <strong class="text-lg font-bold leading-4 text-contrast">
            {{selectedConversation.customer?.name || "-"}}
            {{selectedConversation.customer?.last_name || ''}} </strong
        ><br />
        {{ formatPhoneNumber(selectedConversation.phone) }}<br /><br />
        <div class="flex justify-between mb-8" *ngIf="saleCount">
            <div>
                <strong class="font-bold text-text">Pedidos anteriores</strong>
                <span>{{saleCount}}</span>
            </div>
            <div>
                <strong class="font-bold text-right text-text"
                    >Último pedido</strong
                >
                <span>{{ getTimeAgo(lastSaleDate) }}</span>
            </div>
        </div>
        <div class="mb-8">
            <strong class="font-bold text-text">Dirección</strong><br />
            <span class="text-sm">{{detailAddressUser || "-"}}</span>
        </div>
    </div>
</div>
